export const HEADER_ZOOM_GROUP_CT = 10;
